const mapping = {
  appearance: {
    module: 'appearance',
    prefix: 'appearance',
    values: ['none']
  },
  backgroundAttachment: {
    module: 'backgroundAttachment',
    prefix: 'bg',
    values: ['fixed', 'local', 'scroll']
  },
  backgroundColor: {
    module: 'backgroundColors',
    prefix: 'bg',
    values: 'backgroundColors'
  },
  backgroundPosition: {
    module: 'backgroundPosition',
    prefix: 'bg',
    values: ['bottom', 'center', 'left', 'left-bottom', 'left-top', 'right', 'right-bottom', 'right-top', 'top']
  },
  backgroundRepeat: {
    module: 'backgroundRepeat',
    prefix: 'bg',
    values: { true: 'repeat', false: 'no-repeat', x: 'repeat-x', y: 'repeat-y' }
  },
  backgroundSize: {
    module: 'backgroundSize',
    prefix: 'bg',
    values: 'backgroundSize'
  },
  borderCollapse: {
    module: 'borderCollapse',
    prefix: 'border',
    values: { true: 'collapse', false: 'separate' }
  },
  borderColor: {
    module: 'borderColors',
    prefix: 'border',
    values: 'borderColors',
    coerce: (value, { aliases }) => {
      return ['default', true, 1].includes(value)
        ? aliases.borderColor.default
        : value
    }
  },
  borderRadius: {
    module: 'borderRadius',
    prefix: 'rounded',
    config: { multiple: true, sides: true, corners: true },
    values: 'borderRadius'
  },
  borderStyle: {
    module: 'borderStyle',
    prefix: 'border',
    values: ['solid', 'dashed', 'dotted', 'none']
  },
  borderWidth: {
    module: 'borderWidths',
    prefix: 'border',
    config: { multiple: true, sides: true, axes: true },
    values: 'borderWidths'
  },
  cursor: {
    module: 'cursor',
    prefix: 'cursor',
    values: ['auto', 'default', 'pointer', 'wait', 'move', 'not-allowed']
  },
  display: {
    module: 'display',
    values: ['hidden', 'block', 'inline-block', 'flex', 'inline-flex', 'grid', 'inline-grid', 'inline', 'table', 'table-row', 'table-cell']
  },
  flex: {
    module: 'flexbox',
    prefix: 'flex',
    values: ['1', 'auto', 'initial', 'none']
  },
  flexGrow: {
    module: 'flexbox',
    prefix: 'flex',
    values: { true: 'grow', false: 'no-grow' }
  },
  flexShrink: {
    module: 'flexbox',
    prefix: 'flex',
    values: { true: 'shrink', false: 'no-shrink' }
  },
  flexDirection: {
    module: 'flexbox',
    prefix: 'flex',
    values: ['row', 'row-reverse', 'col', 'col-reverse']
  },
  flexWrap: {
    module: 'flexbox',
    prefix: 'flex',
    values: { true: 'wrap', false: 'no-wrap', reverse: 'wrap-reverse' }
  },
  flexItems: {
    module: 'flexbox',
    prefix: 'items',
    values: ['start', 'end', 'center', 'baseline', 'stretch']
  },
  flexSelf: {
    module: 'flexbox',
    prefix: 'self',
    values: ['start', 'end', 'center', 'auto', 'stretch']
  },
  flexJustify: {
    module: 'flexbox',
    prefix: 'justify',
    values: ['start', 'end', 'center', 'between', 'around']
  },
  flexContent: {
    module: 'flexbox',
    prefix: 'content',
    values: ['start', 'end', 'center', 'between', 'around']
  },
  float: {
    module: 'float',
    prefix: 'float',
    values: ['right', 'left', 'none']
  },
  clearfix: {
    module: 'float',
    values: { true: 'clearfix' }
  },
  font: {
    module: 'fonts',
    prefix: 'font',
    values: 'fonts'
  },
  fontWeight: {
    module: 'fontWeights',
    prefix: 'font',
    values: 'fontWeights'
  },
  height: {
    module: 'height',
    prefix: 'h',
    values: 'height'
  },
  lineHeight: {
    module: 'leading',
    prefix: 'leading',
    values: 'leading'
  },
  listStyle: {
    module: 'lists',
    prefix: 'list',
    values: { none: 'reset' }
  },
  margin: {
    module: 'margin',
    prefix: 'm',
    config: { multiple: true, sides: true, axes: true },
    values: 'margin'
  },
  maxHeight: {
    module: 'maxHeight',
    prefix: 'max-h',
    values: 'maxHeight'
  },
  maxWidth: {
    module: 'maxWidth',
    prefix: 'max-w',
    values: 'maxWidth'
  },
  minHeight: {
    module: 'minHeight',
    prefix: 'min-h',
    values: 'minHeight'
  },
  minWidth: {
    module: 'minWidth',
    prefix: 'min-w',
    values: 'minWidth'
  },
  negativeMargin: {
    module: 'negativeMargin',
    prefix: '-m',
    config: { multiple: true, sides: true, axes: true },
    values: 'negativeMargin'
  },
  objectFit: {
    module: 'objectFit',
    prefix: 'object',
    values: ['contain', 'cover', 'fill', 'none', 'scale-down']
  },
  objectPosition: {
    module: 'objectPosition',
    prefix: 'object',
    values: ['bottom', 'center', 'left', 'left-bottom', 'left-top', 'right', 'right-bottom', 'right-top', 'top']
  },
  opacity: {
    module: 'opacity',
    prefix: 'opacity',
    values: 'opacity'
  },
  outline: {
    module: 'outline',
    prefix: 'outline',
    values: ['none']
  },
  overflow: {
    module: 'overflow',
    prefix: 'overflow',
    config: { multiple: true, axes: true },
    values: ['auto', 'hidden', 'visible', 'scroll']
  },
  scrolling: {
    module: 'overflow',
    prefix: 'scrolling',
    values: ['touch', 'auto']
  },
  padding: {
    module: 'padding',
    prefix: 'p',
    config: { multiple: true, sides: true, axes: true },
    values: 'padding'
  },
  pointerEvents: {
    module: 'pointerEvents',
    prefix: 'pointer-events',
    values: { true: 'none', false: 'auto' }
  },
  position: {
    module: 'position',
    values: ['static', 'fixed', 'absolute', 'relative', 'sticky']
  },
  pin: {
    module: 'position',
    prefix: 'pin',
    config: { multiple: true, sides: true, axes: true },
    values: ['none', 'default', 'x', 'y', 't', 'r', 'b', 'l']
  },
  resize: {
    module: 'resize',
    prefix: 'resize',
    values: ['none', 'default', 'x', 'y']
  },
  shadow: {
    module: 'shadows',
    prefix: 'shadow',
    values: 'shadows'
  },
  fill: {
    module: 'svgFill',
    prefix: 'fill',
    values: 'svgFill'
  },
  stroke: {
    module: 'svgStroke',
    prefix: 'stroke',
    values: 'svgStroke'
  },
  textAlign: {
    module: 'textAlign',
    prefix: 'text',
    values: ['left', 'center', 'right', 'justify']
  },
  color: {
    module: 'textColors',
    prefix: 'text',
    values: 'textColors'
  },
  fontSize: {
    module: 'textSizes',
    prefix: 'text',
    values: 'textSizes'
  },
  fontStyle: {
    module: 'textStyle',
    values: ['italic', 'roman']
  },
  textTransform: {
    module: 'textStyle',
    values: ['uppercase', 'lowercase', 'capitalize', 'normal-case']
  },
  textDecoration: {
    module: 'textStyle',
    values: ['underline', 'line-through', 'no-underline']
  },
  fontSmoothing: {
    module: 'textStyle',
    values: ['antialiased', 'subpixel-antialiased']
  },
  letterSpacing: {
    module: 'tracking',
    prefix: 'tracking',
    values: 'tracking'
  },
  userSelect: {
    module: 'userSelect',
    prefix: 'select',
    values: { true: 'none', false: 'text' }
  },
  verticalAlign: {
    module: 'verticalAlign',
    prefix: 'align',
    values: ['baseline', 'top', 'middle', 'bottom', 'text-top', 'text-bottom']
  },
  visibility: {
    module: 'visibility',
    values: { true: 'visible', false: 'invisible' }
  },
  whiteSpace: {
    module: 'whitespace',
    prefix: 'whitespace',
    values: ['normal', 'no-wrap', 'pre', 'pre-line', 'pre-wrap']
  },
  wordWrap: {
    module: 'whitespace',
    prefix: 'break',
    values: ['words', 'normal']
  },
  textTruncate: {
    module: 'whitespace',
    values: { true: 'truncate' }
  },
  width: {
    module: 'width',
    prefix: 'w',
    values: 'width'
  },
  zIndex: {
    module: 'zIndex',
    prefix: 'z',
    values: 'zIndex'
  },
  container: {
    module: 'container',
    values: { true: 'container', half: 'half-container', false: 'full-container' }
  },
  aspectRatio: {
    module: 'ratio',
    prefix: 'ratio',
    values: 'ratios'
  },
  gridColumns: {
    module: 'grid',
    prefix: 'grid-col',
    values: 'gridColumns'
  },
  gridColumnSpan: {
    module: 'grid',
    prefix: 'col-span',
    values: 'gridColumns'
  },
  gridColumnStart: {
    module: 'grid',
    prefix: 'col-start',
    values: 'gridColumns'
  },
  gridColumnEnd: {
    module: 'grid',
    prefix: 'col-end',
    values: 'gridColumns'
  },
  gridColumnOrder: {
    module: 'grid',
    prefix: 'col-order',
    values: 'gridColumns'
  },
  gridGap: {
    module: 'grid',
    prefix: 'grid-gap',
    values: 'gridGaps'
  },
  gridAutoFlow: {
    module: 'grid',
    prefix: 'auto-flow',
    values: ['row', 'col', 'dense']
  },
  gridAutoFit: {
    module: 'grid',
    prefix: 'auto-fit',
    values: 'gridWidths'
  },
  gridAutoFill: {
    module: 'grid',
    prefix: 'auto-fill',
    values: 'gridWidths'
  },
  flexGrid: {
    module: 'flexGrid',
    prefix: 'flex',
    values: { true: 'grid' }
  },
  flexColumns: {
    module: 'flexGrid',
    prefix: 'flex-col',
    values: 'gridColumns'
  },
  flexColSpan: {
    module: 'flexGrid',
    prefix: 'col',
    values: 'gridColumns'
  },
  flexColOffset: {
    module: 'flexGrid',
    prefix: 'off',
    values: 'gridColumns'
  },
  flexGap: {
    module: 'flexGrid',
    prefix: 'flex-gap',
    values: 'gridGaps'
  },
  flexAutoFill: {
    module: 'flexGrid',
    prefix: 'flex-basis',
    values: 'gridWidths'
  },
  stack: {
    module: 'stack',
    values: { true: 'stack' }
  },
  stackDirection: {
    module: 'stack',
    prefix: 'stack',
    values: ['row', 'row-reverse', 'col', 'col-reverse']
  },
  stackGap: {
    module: 'stack',
    prefix: 'stack-gap',
    values: 'gridGaps'
  },

  // TODO: Remove when replaced in projects
  textColor: {
    module: 'textColors',
    prefix: 'text',
    values: 'textColors'
  },
  leading: {
    module: 'leading',
    prefix: 'leading',
    values: 'leading'
  },
  list: {
    module: 'lists',
    prefix: 'list',
    values: ['reset']
  },
  textSize: {
    module: 'textSizes',
    prefix: 'text',
    values: 'textSizes'
  }
}

export default mapping
